import { toast } from 'react-toastify'
import { postMPDataWithParams } from 'src/mentor/services'
import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'

const ERROR_MESSAGES = {
  9910: 'Unable to save your feedback. Please try again.',
  9913: 'The screening report could not be found. Please refresh and try again.',
  9914: 'You are not authorized to provide feedback for this screening report.',
  default: 'Failed to submit feedback. Please try again.',
}

const logError = (errorCode, errorMessage, fullResponse) => {
  const errorContext = {
    code: errorCode,
    message: errorMessage,
    fullResponse,
  }

  console.error('API Response Error:', errorContext)

  // Log specific error details
  switch (errorCode) {
    case 9910:
      console.error('Error saving screening feedback:', errorMessage)
      break
    case 9913:
      console.error('Screening report not found:', errorMessage)
      break
    case 9914:
      console.error('Doctor not authorized for this screening report:', errorMessage)
      break
    default:
      console.error('Unexpected response:', fullResponse)
  }
}

export const submitScreeningFeedback = async (
  feedbackObject,
  isThearpySuggested = false,
  isDiagnosisGiven = false,
) => {
  try {
    const payload = {
      ...feedbackObject,
      diagnosisAgreement: isDiagnosisGiven ? feedbackObject.diagnosisAgreement : 'NO_DIAGNOSIS_GIVEN',
      therapyRecommendationAgreement: isThearpySuggested
        ? feedbackObject.therapyRecommendationAgreement
        : 'NOT_SUGGESTED',
    }

    const response = await postMPDataWithParams('/api/secure/doctor/screening-feedback', payload)

    if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
      toast.success('Feedback submitted successfully!')
      return { success: true }
    } else {
      const errorCode = response?.data?.code
      const errorMessage = response?.data?.message || 'Unknown error'

      logError(errorCode, errorMessage, response)

      const userMessage = ERROR_MESSAGES[errorCode] || ERROR_MESSAGES.default
      toast.error(userMessage)

      return { success: false, errorCode, errorMessage }
    }
  } catch (error) {
    console.error('Error submitting feedback:', error)
    toast.error(ERROR_MESSAGES.default)
    return { success: false, error }
  }
}
